import Axios from "../../../networking/interceptor";

import { createAsyncThunk } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import { driver_chat_users } from "../../../networking/urlEndPoints";

export const getContactList = createAsyncThunk('getContactList', async (_, { rejectWithValue }) => {
    try {
        const response = await Axios.get(driver_chat_users)
        const data = response.data;
        return data;
    } catch (error) {
        return rejectWithValue(error.response)
    }
})

const initialState = {
    loading: false,
    data: null,
    error: null
}

const getContactListSlice = createSlice({
    name: 'getContactList',
    initialState,

    extraReducers: (builder) => {
        builder.addCase(getContactList.pending.type, (state) => {
            return {
                ...state,
                loading: true,
                data: null,
                error: null
            }
        })

        builder.addCase(getContactList.fulfilled.type, (state, action) => {
            return {
                ...state,
                loading: false,
                data: action.payload,
                error: null
            }
        })

        builder.addCase(getContactList.rejected.type, (state, action) => {
            return {
                ...state,
                loading: false,
                data: null,
                error: action.payload
            }
        })
    }

})

export default getContactListSlice.reducer